module.exports = __webpack_public_path__ + "static/img/2.ec55030.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/15/sp/2.png
// module id = EuAM
// module chunks = 0